export function getTransformControlsModeForShortcut(event, currentMode = "translate") {
  if (!event) {
    return currentMode;
  }

  const key = typeof event.key === "string" ? event.key.toLowerCase() : "";
  const code = typeof event.code === "string" ? event.code : "";
  const keyCode = event.keyCode || event.which;

  if (key === "e" || code === "KeyE" || keyCode === 69 || keyCode === 101) {
    return "scale";
  }

  if (key === "r" || code === "KeyR" || keyCode === 82 || keyCode === 114) {
    return "rotate";
  }

  if (key === "w" || code === "KeyW" || keyCode === 87 || keyCode === 119) {
    return "translate";
  }

  return currentMode;
}
